import React from "react";
import { useState } from "react";
import { Navigation } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import "../../Styles/MotionDastani.css";
// import "./styles.css";

const MotionDastani = ({ slides }) => {
  return (
    <Swiper
      navigation={true}
      onNavigationNext={() => console.log("next")}
      className={"MotionDastani_swiper-wrapper"}
    >
      <SwiperSlide>
        <iframe
          src="https://www.aparat.com/video/video/embed/videohash/15c96/vt/frame?titleShow=true&recom=self"
          allowFullScreen="true"
          webkitallowfullscreen="true"
          mozallowfullscreen="true"
          className="MotionDastani_img"
        ></iframe>
      </SwiperSlide>
      <SwiperSlide>
        <iframe
          src="https://www.aparat.com/video/video/embed/videohash/juZBR/vt/frame?titleShow=true&recom=self"
          allowFullScreen="true"
          webkitallowfullscreen="true"
          mozallowfullscreen="true"
          className="MotionDastani_img"
        ></iframe>
      </SwiperSlide>
      <SwiperSlide>
        <iframe
          src="https://www.aparat.com/video/video/embed/videohash/9TCvF/vt/frame?titleShow=true&recom=self"
          allowFullScreen="true"
          webkitallowfullscreen="true"
          mozallowfullscreen="true"
          className="MotionDastani_img"
        ></iframe>
      </SwiperSlide>
      <SwiperSlide>
        <iframe
          src="https://www.aparat.com/video/video/embed/videohash/M2Y3h/vt/frame?titleShow=true&recom=self"
          allowFullScreen="true"
          webkitallowfullscreen="true"
          mozallowfullscreen="true"
          className="MotionDastani_img"
        ></iframe>
      </SwiperSlide>
      <SwiperSlide>
        <iframe
          src="https://www.aparat.com/video/video/embed/videohash/R9pFs/vt/frame?titleShow=true&recom=self"
          allowFullScreen="true"
          webkitallowfullscreen="true"
          mozallowfullscreen="true"
          className="MotionDastani_img"
        ></iframe>
      </SwiperSlide>
      <SwiperSlide>
        <iframe
          src="https://www.aparat.com/video/video/embed/videohash/rFtiE/vt/frame?titleShow=true&recom=self"
          allowFullScreen="true"
          webkitallowfullscreen="true"
          mozallowfullscreen="true"
          className="MotionDastani_img"
        ></iframe>
      </SwiperSlide>
    </Swiper>
  );
};
MotionDastani.defaultProps = {};
export default MotionDastani;
